export const BadgeCritical = ({ variant = 'default' }: { variant?: 'default' | 'simple' }) => {
  if (variant === 'simple') {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="8" cy="8" r="8" fill="#EF4444" />
        <path
          d="M8.7145 4.1818L8.6005 8.6625H7.3995L7.2855 4.1818H8.7145ZM7.9985 11.299C7.7955 11.299 7.6135 11.2125 7.4525 11.0395C7.2985 10.867 7.221 10.658 7.221 10.4125C7.221 10.1715 7.2985 9.966 7.4525 9.796C7.6135 9.6225 7.7955 9.536 7.9985 9.536C8.195 9.536 8.373 9.6225 8.533 9.796C8.7 9.966 8.784 10.1715 8.7875 10.4125C8.784 10.577 8.739 10.726 8.6525 10.859C8.569 10.992 8.4585 11.0985 8.321 11.178C8.187 11.2575 8.0325 11.299 7.9985 11.299Z"
          fill="white"
        />
      </svg>
    );
  }

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_5233_1341)">
        <circle cx="12" cy="8" r="8" fill="white" />
      </g>
      <path
        d="M13.0717 3.27273L12.8757 9.32812H11.1243L10.9283 3.27273H13.0717ZM11.9979 12.1236C11.6939 12.1236 11.4325 12.0156 11.2138 11.7997C10.9979 11.5838 10.8899 11.3224 10.8899 11.0156C10.8899 10.7145 10.9979 10.4574 11.2138 10.2443C11.4325 10.0284 11.6939 9.92045 11.9979 9.92045C12.2905 9.92045 12.5476 10.0284 12.7692 10.2443C12.9936 10.4574 13.1058 10.7145 13.1058 11.0156C13.1058 11.2202 13.0533 11.4062 12.9482 11.5739C12.8459 11.7415 12.7109 11.875 12.5433 11.9744C12.3786 12.0739 12.1967 12.1236 11.9979 12.1236Z"
        fill="#E94C49"
      />
      <defs>
        <filter
          id="filter0_d_5233_1341"
          x="0"
          y="0"
          width="24"
          height="24"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.366098 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5233_1341" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5233_1341"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
